import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n';
import './registerServiceWorker';
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios'
import 'bootstrap/dist/js/bootstrap.min'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import form from '@/components/form/index'
import filter from '@/components/filter/index'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import moment from 'vue-moment';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import {bus} from './bus';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
    Vue,
    dsn: "https://30b0faaef6a74317b06beb16a072ddd1@o1288820.ingest.sentry.io/6506437",
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["admin.phonenet.io"],
        }),
    ],
    tracesSampleRate: 1.0,
});

Vue.component('v-select', vSelect);
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(form);
Vue.use(filter);
Vue.use(moment);
Vue.filter('numFormat', numFormat(numeral));

const serviceUrl = process.env.VUE_APP_SERVICE_URL;

const service = axios.create({
    baseURL: serviceUrl,
    timeout: 180000,
});

service.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (!error.response) {
        Vue.swal({
            text: 'Cannot connect to Phonenet server!',
            icon: 'error'
        });
    } else if (error.response.status === 401) {
        service.defaults.headers.common['token'] = null;
        bgService.defaults.headers.common['token'] = null;
        sessionStorage.removeItem('token');
        localStorage.removeItem('token');
        location.reload();
    } else if (error.response.status === 500 || error.response.status === 404 || error.response.status === 404) {
        if (error.response.data.message) {
            Vue.swal({
                text: error.response.data.message,
                icon: 'error'
            });
        } else {
            Vue.swal({
                text: error.message,
                icon: 'error'
            });
        }
    }
    return Promise.reject(error);
});

const bgService = axios.create({
    baseURL: serviceUrl,
    timeout: 30000,
});

bgService.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

service.defaults.headers.common['Accept-Language'] = i18n.locale;
bgService.defaults.headers.common['Accept-Language'] = i18n.locale;

Vue.prototype.$service = service;
Vue.prototype.$bgService = bgService;
Vue.prototype.$bus = bus;

Vue.config.productionTip = false;

Vue.use(VueLoading, {
    backgroundColor: '#212529',
    color: '#007bff',
    opacity: 0.25,
    zIndex: 9999,
    width: 128,
    height: 128
});

router.beforeEach(function (to, from, next) {
    const publicPages = ['/login', '/forgot', '/reset', '/top-sales'];
    let authRequired = true;
    publicPages.forEach(function (val) {
        if (to.path.startsWith(val)) {
            authRequired = false;
            return;
        }
    });
    if (authRequired) {
        if (!store.state.user) {
            return next('/login');
        }
    }
    next();
});

const mount = function () {
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount('#app');
};

let token = localStorage.getItem('token');

if (token) {
    store.commit('token', token);
    let loader = Vue.$loading.show();
    service.get('/profile').then(response => {
        store.commit('user', response.data);
    }).finally(() => {
        loader.hide();
        mount();
    });
} else {
    mount();
}
